module.exports = __webpack_public_path__ + "static/media/map-pin-delivery.28981217.svg";